export default "__VITE_ASSET__CD$IffOP__"